import { render, staticRenderFns } from "./SwitchKiosk.vue?vue&type=template&id=fc4b6bb6&scoped=true&"
import script from "./SwitchKiosk.vue?vue&type=script&lang=js&"
export * from "./SwitchKiosk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4b6bb6",
  null
  
)

export default component.exports